const BACKGROUND_MODAL_TITLE_COMPONENT_PROPS = {
  showBuilder: false,
};
export { BACKGROUND_MODAL_TITLE_COMPONENT_PROPS };
